<script lang="ts" setup>
import type { IssueList } from '~/services/generated/client/public'
import { CfgIssuesCard } from '@cfgtech/ui'
import { ROUTES } from '~/constants/routes'
import { DataLayerEventsEnum } from '~/types/dataLayer'

const { issue } = defineProps<{ issue: IssueList }>()

const {
  collaterals,
  interestRateFormatted,
  progress,
  info,
  header,
  monthsUntilMaturity,
  maturityLabel,
} = useIssuesDataCommon(issue)

const trackEvent = useTrackEvent()
</script>

<template>
  <CfgIssuesCard
    :key="issue.id"
    :button-label="$t('issue.detailButton')"
    :collaterals
    :header
    :info
    :interest-rate-formatted="`${interestRateFormatted} %`"
    :issue-url="`${ROUTES.ISSUE}/${issue.slug}`"
    :maturity-label
    :months-until-maturity
    :name="issue.overview.projectName || issue.projectName || issue.name"
    :progress="progress"
    :rating="issue.rating"
    @open-issue="navigateTo(`${ROUTES.ISSUE}/${issue.slug}`)"
    @open-issue-by-button="trackEvent({
      eventName: DataLayerEventsEnum.Click,
      clickData: {
        id: 'b~project_card~button_secondary~product_detail~$~$~0',
        text: $t('issue.detailButton'),
        url: getFullPath(`${ROUTES.ISSUE}/${issue.slug}`),
        value: 0,
      },
    })"
  >
    <template #collateralsCta>
      <IssuesCtaBanner />
    </template>
  </CfgIssuesCard>
</template>

<style>
.button.issue-card-button {
  --padding-y: 0.375rem;
  --padding-x: 0.375rem;
}
</style>
